<template>
  <div class="grouplist-wrap">
    <div class="bread-wrap">
      <span class="bread-title">分组列表</span>
    </div>
    <div class="content">
      <div class="list-top">
        <el-button type="primary" @click="ifshowcreate" class="creategroup"
          >创建分组</el-button
        >
      </div>
      <com-table
        class="grouplist"
        :headercellstyle="headercellstyle"
        :columns="grouplist"
        :pagination="pagination"
        tableheight="calc(100vh - 300px)"
        :data="tabledata"
      >
        <el-table-column
          align="center"
          header-align="center"
          slot="action"
          fixed="right"
          label="操作"
          min-width="150"
        >
          <template slot-scope="scope">
            <el-button
              @click="deletegroup(scope.row)"
              class="deletebtn"
              size="mini"
              type="primary"
              >删除</el-button
            >
            <el-button
              @click="editegroup(scope.row)"
              class="resetbtn"
              size="mini"
              type="primary"
              >修改</el-button
            >
          </template>
        </el-table-column>
      </com-table>
    </div>
    <create-group
      :title="`${title}分组`"
      canceltext="取消"
      confirmtext="确定"
      :showcreate="showcreate"
      @closecreate="closecreate"
      :row="row"
    />
    <delete-group
      title="删除分组"
      canceltext="取消"
      confirmtext="确定"
      :showdelete="showdelete"
      @closedelete="closedelete"
      :row="row"
    />
  </div>
</template>
<script>
import CreateGroup from "./Models/CreateGroup";
import DeleteGroup from "./Models/DeleteGroup";
import ComTable from "@/components/Table";
import { grouplist } from "@/utils/tableList";
export default {
  name: "grouplist",
  data() {
    return {
      grouplist,
      pagination: {
        current: 1,
        size: 20,
        total: 1,
      },
      tabledata: [],
      headercellstyle: {
        background: "rgba(228, 229, 241)",
        color: "rgba(102,102,102)",
      },
      showcreate: false,
      showdelete: false,
      row: {},
      title: "",
    };
  },
  components: {
    ComTable,
    CreateGroup,
    DeleteGroup,
  },
  mounted() {
    this.getgrouplist();
    this.getuserinfo();
  },
  methods: {
    getgrouplist() {
      this.$store.dispatch("group/getgrouplist").then((res) => {
        // console.log("group list: " + JSON.stringify(res));
        if (res.RetCode == 0) {
          this.tabledata = res.Groups;
        }
      });
    },
    deletegroup(row) {
      if (row.Name == "默认分组") {
        this.$message.warning("默认分组无法删除!");
        return;
      }
      this.row = row;
      this.showdelete = !this.showdelete;
    },
    editegroup(row) {
      if (row.Name == "默认分组") {
        this.$message.warning("默认分组名称不支持修改!");
        return;
      }
      this.title = "编辑";
      this.row = row;
      this.showcreate = !this.showcreate;
    },
    ifshowcreate() {
      this.title = "创建";
      this.showcreate = !this.showcreate;
    },
    closecreate() {
      this.getgrouplist();
      this.showcreate = !this.showcreate;
    },
    closedelete() {
      this.getgrouplist();
      this.showdelete = !this.showdelete;
    },
    getuserinfo() {
      this.$store.dispatch("user/getuserinfo").then((res) => {
        if (res.RetCode == 0) {
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>